import { queryClient } from '@/api/queryClient.ts'
import { QueryCacheKeys } from '@/api/queryKeys.ts'

type AlertLiveEvent = 'emergency' | 'fall' | 'bio'

/** 이벤트 → 폴링 훅이 쓰는 queryKey 와 데이터의 배열 필드 */
const TARGETS: Record<AlertLiveEvent, { key: () => readonly unknown[]; field: string }> = {
    emergency: {
        key: () => QueryCacheKeys.notification.getEmergencyAlertLive(),
        field: 'emergencies'
    },
    fall: {
        key: () => QueryCacheKeys.notification.apiGetAlertFallDetectionLive(),
        field: 'falls'
    },
    bio: { key: () => QueryCacheKeys.notification.getAlertBioLive(), field: 'bios' }
}

const isLiveEvent = (event: string): event is AlertLiveEvent => event in TARGETS

/**
 * 스트림 이벤트를 폴링 훅의 캐시에 그대로 넣는다.
 * 폴링 queryFn 이 `{data}` 를 벗겨 캐시에 `{emergencies}`·`{falls}`·`{bios}` 를 두므로 같은 모양이다.
 *
 * @returns 캐시에 반영했으면 true
 */
export const applyAlertStreamEvent = (event: string, data: unknown): boolean => {
    if (!isLiveEvent(event)) return false

    const target = TARGETS[event]
    const list = (data as Record<string, unknown> | null)?.[target.field]
    if (!Array.isArray(list)) return false

    queryClient.setQueryData(target.key(), data)
    return true
}
